import { Constants } from './Constants';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../shared/config/app-config';
import { UserService, PatientService, User } from '../shared';
import { locale } from 'devextreme/localization';
@Pipe({
  name: 'dateFormat',
  pure: true
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  dateform: string;
  currentUser: User;
  constructor(private userService: UserService,private Datepipe:DatePipe)
  {
    super('');
  }
  override transform(value: any, args?: any): any {
    if(value != undefined){
    var dateStr = value.replace('00:00:00.0', '');
    try{
    var result
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if(this.currentUser.item){
          if(this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy'){
            this.dateform = environment.dateForm;
          }else if(this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy'){
            this.dateform = 'dd/MM/yyyy'
          }
          result = this.Datepipe.transform(dateStr, this.dateform);
        }
      }
    );
    }catch (Exception){}
    return result;
  }
  }
}
// @Pipe({
//   name: 'dateTimeFormat',
//   pure: true
// })
// export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
//   dateform: string;
//   currentUser: User;
//   constructor(private userService: UserService,private Datepipe:DatePipe)
//   {
//     super('');
//   }
//   transform(value: any, args?: any): any {
//     if(value != undefined){
//       var dateStr = value.replace(' ', 'T')+"+01:00";
//     try{
//       var result
//       this.userService.currentUser.subscribe(
//         (userData) => {
//           this.currentUser = userData;
//           if(this.currentUser.item){
//             if(this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy'){
//               this.dateform = environment.dateForm;
//             }else if(this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy'){
//               this.dateform = 'dd/MM/yyyy'
//             }
//             result = this.Datepipe.transform(dateStr, this.dateform);
//           }
//         }
//       );
//     }catch (Exception){}
//     return result;
//   }
//   }
// }